import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
/**
 * @component Case
 * @since 1.0.0
 */
export function When(props) {
    let match = false;
    const children = React.Children.map(props.children, (value) => {
        switch (value.type) {
            case Case:
                if (match == false) {
                    match = Boolean(value.props.is);
                }
                break;
            case Else:
                if (match) {
                    return null;
                }
                break;
        }
        return value;
    });
    return React.createElement(Fragment, null, children);
}
